<template>
  <div class="tool" v-on:click="toolSelected" v-if="tool.visible" :class="{ 'active': tool.selected } ">
    <glossary-icon v-if="tool.class === 'glossary'"></glossary-icon>
    <cite-this-icon v-if="tool.class === 'cite-this'"></cite-this-icon>
    <source-notes-icon v-if="tool.class === 'source-notes'"></source-notes-icon>
    <div class="label rounded-full body-13" v-html="tool.name"></div>
  </div>
</template>

<script>
  import GlossaryIcon from "@/component/GlossaryIcon";
  import CiteThisIcon from "@/component/CiteThisIcon";
  import SourceNotesIcon from "@/component/SourceNotesIcon";

  export default {
    name: 'ToolTab',

    components: {
      SourceNotesIcon,
      CiteThisIcon,
      GlossaryIcon
    },

    props: {
      tool: {
        required: true
      },
    },

    data() {
      return {
        isActive: false,
      }
    },

    methods: {
      toolSelected: function () {
        this.$emit('tool-selected', this.tool);
      }
    },
  }
</script>

<style lang="scss">
  .tool {
    height: 38px;
    width: 46px;
    margin-top: 2px;
    display: flex;
    position: relative;
    align-items: center;
    border-radius: 15px 15px 0 0;
    z-index: 10;

    &:hover {
      @apply bg-grey-5;
      cursor: pointer;

      svg {
        path {
          fill: config('colors.grey-2');
        }
      }

      .label {
        position: absolute;
        display: block;
        color: #989898;
        text-align: center;
        @apply bg-grey-5;
        height: 24px;
        min-width: 75px;
        width: max-content;
        bottom: -24px;
        padding-left: 5px;
        padding-right: 5px;
        left: 50%;
        transform: translateX(-50%);
      }

      &:after,
      &:before {
        content: '';
        width: 5px;
        height: 10px;
        border-width: 3px;
        border-style: solid;
        position: absolute;
        border-top: 0;
        bottom: -3px;
        @apply border-grey-5;
      }

      &:after {
        border-left: 0;
        border-radius: 0 0 25px 0;
        left: -2px;
      }

      &:before {
        border-right: 0;
        border-radius: 0 0 0 25px;
        right: -2px;
      }
    }

    &.active {
      @apply bg-grey-5;
      border-radius: 15px 15px 0 0;


      svg {
        path {
          fill: config('colors.grey-2');
        }
      }

      &:after,
      &:before {
        content: '';
        width: 5px;
        height: 10px;
        border-width: 3px;
        border-style: solid;
        position: absolute;
        border-top: 0;
        bottom: -3px;
        @apply border-grey-5;
      }

      &:after {
        border-left: 0;
        border-radius: 0 0 25px 0;
        left: -2px;
      }

      &:before {
        border-right: 0;
        border-radius: 0 0 0 25px;
        right: -2px;
      }
    }

    &.active:hover {

      .label {
        display: none;
      }
    }

    .label {
      display: none;
    }

    .glossary {
      width: 46px;
      height: 26px;
      background: no-repeat url("../assets/images/50a-lrn-spt-prof-gloss-icon-def.svg") center;
    }

    .source-notes {
      width: 46px;
      height: 26px;
      background: no-repeat url("../assets/images/51a-lrn-spt-prof-note-icon-def.svg") center;
    }

    .cite-this {
      width: 46px;
      height: 26px;
      background: no-repeat url("../assets/images/52a-lrn-spt-prof-cite-icon-def.svg") center;
    }
  }

</style>
